import { jwtDecode } from 'jwt-decode';

export const refreshNetchexLogin = () => {
  const urlParams = new URLSearchParams();
  urlParams.set('redirectTo', window.location.href);
  window.location.href = `${process.env.PUBLIC_APP_NETCHEX_LOGIN_URL}/RefreshAccessToken?${urlParams.toString()}`;
};

export const checkIsExpiredJWTToken = (token) => {
  const jwt = jwtDecode(token);
  if (jwt.exp - Math.floor(Date.now() / 1000) <= 0) {
    return true;
  }
  return false;
};
